import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  createLoading: false,
  stockHistories: {
    data: [],
    meta: {
      total: 0,
      from: 0,
      to: 0,
      current_page: 0,
      last_page: 0,
      per_page: 0,
    },
  },
};

export const fetchStockHistories = createAsyncThunk(
  "fetchStockHistories/history",
  async (
    { enqueueSnackbar, page = 1, limit = 10, ...otherParams },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.get("stock-histories", {
        params: {
          page,
          limit,
          ...otherParams,
        },
      });

      const apiData = response.data.data;

      return {
        data: apiData.data,
        meta: {
          total: apiData.total,
          from: apiData.from,
          to: apiData.to,
          current_page: apiData.current_page,
          last_page: apiData.last_page,
          per_page: apiData.per_page,
        },
      };
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch stock histories";
      if (enqueueSnackbar) {
        enqueueSnackbar(message, { variant: "error" });
      }
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const createStockHistory = createAsyncThunk(
  "createStockHistory/history",
  async ({ data, enqueueSnackbar, onSuccess }, thunkApi) => {
    try {
      const response = await axiosInstance.post("stock-histories", data);
      if (enqueueSnackbar) {
        enqueueSnackbar("Stock adjusted successfully", { variant: "success" });
      }
      if (onSuccess) {
        onSuccess();
      }
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to adjust stock";
      if (enqueueSnackbar) {
        enqueueSnackbar(message, { variant: "error" });
      }
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const stockHistorySlice = createSlice({
  name: "stockHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchStockHistories.pending, (state) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchStockHistories.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.stockHistories = action.payload;
    });

    builder.addCase(fetchStockHistories.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    builder.addCase(createStockHistory.pending, (state) => {
      state.createLoading = true;
    });

    builder.addCase(createStockHistory.fulfilled, (state) => {
      state.createLoading = false;
    });

    builder.addCase(createStockHistory.rejected, (state, action) => {
      state.createLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default stockHistorySlice.reducer;
